/* eslint-disable */
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import Sidebar from "../../components/sidebar/Sidebar2";
import Navbar from "../../components/navbar/Navbar2";
import Footer from "../../components/footer/Footer";
import ActivationGoogleSheetAbndn from "../../components/services/Activation/ActivationGoogleSheetAbndn";
import { useSelector } from "react-redux";
import { DHD_PLAN_NAME } from "../../components/DhdCurrentPlanBanner";

export default function OrdersAbndnSheet() {
  const account = useSelector((state) => state.AccountReducer);
  const isDhdUser =
    account?.subscription?.plan === DHD_PLAN_NAME &&
    account?.subscription?.dhdPartnershipActive === true;

  const { i18n } = useTranslation();
  const [showSideBar, setShowSideBar] = useState(true);
  const isRTL = i18n.dir() === "rtl";

  useEffect(() => {
    function handleResize() {
      if (window.innerWidth <= 1080) {
        setShowSideBar(false);
      } else {
        setShowSideBar(true);
      }
    }

    window.addEventListener("resize", handleResize);
    handleResize();
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div
      className="container-fluid bg-purple-50 min-h-screen dark:!bg-[#141414]"
      dir={isRTL ? "rtl" : "ltr"}
    >
      <div className="row">
        {showSideBar && (
          <div
            style={{
              width: "250px",
              flexShrink: 0,
              transition: "width 0.6s ease",
              boxShadow: "2px 0 10px rgba(0,0,0,0.05)",
            }}
          >
            <Sidebar
              showSideBar={showSideBar}
              setShowSideBar={setShowSideBar}
            />
          </div>
        )}

        <div
          className="px-3 dark:!bg-[#141414]"
          style={{ flex: 1, backgroundColor: "#fbf8fc" }}
        >
          <Navbar showSideBar={showSideBar} setShowSideBar={setShowSideBar} />
          <div className="m-3">
            {isDhdUser ? null : <ActivationGoogleSheetAbndn />}
          </div>
          <Footer />
        </div>
      </div>
    </div>
  );
}
